class Bootstrap {
    static setup = async () => {
        const exports = {};

        const alerts = [
            ...document.querySelectorAll("[data-bs-dismiss='alert']"),
        ];
        if (0 < alerts.length) {
            exports.Alert = (await import("bootstrap/js/dist/alert")).default;
        }

        const buttons = [
            ...document.querySelectorAll("[data-bs-toggle='button']"),
        ];
        if (0 < buttons.length) {
            exports.Button = (await import("bootstrap/js/dist/button")).default;
        }

        const carousels = [...document.querySelectorAll(".carousel")];
        if (0 < carousels.length) {
            exports.Carousel = (
                await import("bootstrap/js/dist/carousel")
            ).default;
            // noinspection JSUnusedAssignment,JSValidateTypes
            //carousels = carousels.map((el) => new exports.Carousel(el));
        }

        const collapsibles = [
            ...document.querySelectorAll(
                "[data-bs-toggle='collapse'][data-bs-target], [data-bs-toggle='collapse'][href^='#']",
            ),
        ];
        if (0 < collapsibles.length) {
            exports.Collapse = (
                await import("bootstrap/js/dist/collapse")
            ).default;
            this.#setupAccordions(exports.Collapse);
        }

        const dropdowns = [
            ...document.querySelectorAll("[data-bs-toggle='dropdown']"),
        ];
        if (0 < dropdowns.length) {
            exports.Dropdown = (
                await import("bootstrap/js/dist/dropdown")
            ).default;
        }

        const modals = [
            ...document.querySelectorAll(
                "[data-bs-toggle='modal'][data-bs-target], [data-bs-toggle='modal'][href^='#'], [data-bs-dismiss='modal']",
            ),
        ];
        if (0 < modals.length) {
            exports.Modal = (await import("bootstrap/js/dist/modal")).default;
        }

        const offcanvases = [
            ...document.querySelectorAll(
                "[data-bs-toggle='offcanvas'][data-bs-target], [data-bs-toggle='offcanvas'][href^='#'], [data-bs-dismiss='offcanvas']",
            ),
        ];
        if (0 < offcanvases.length) {
            exports.Offcanvas = (
                await import("bootstrap/js/dist/offcanvas")
            ).default;
        }

        const scrollspies = [
            ...document.querySelectorAll(
                "[data-bs-spy='scroll'][data-bs-target]",
            ),
        ];
        if (0 < scrollspies.length) {
            exports.Scrollspy = (
                await import("bootstrap/js/dist/scrollspy")
            ).default;
        }

        const tabs_pills = [
            ...document.querySelectorAll(
                "[data-bs-toggle='tab'], [data-bs-toggle='pill']",
            ),
        ];
        if (0 < tabs_pills.length) {
            exports.Tab = (await import("bootstrap/js/dist/tab")).default;
            const stopPropagation = (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
            };
            tabs_pills.forEach((el) =>
                el.addEventListener("shown.bs.tab", () => {
                    window.addEventListener("hashchange", stopPropagation);
                    window.location.hash = `#${el.id}`;
                    window.removeEventListener("hashchange", stopPropagation);
                }),
            );
            const changeTab = (autofocus = false) => {
                if (!window.location.hash) {
                    return;
                }

                const btn = document.querySelector(window.location.hash);
                if (
                    btn &&
                    ["pill", "tab"].includes(btn.getAttribute("data-bs-toggle"))
                ) {
                    // noinspection JSValidateTypes
                    const bsTab = new exports.Tab(btn);
                    bsTab.show();

                    if (autofocus) {
                        const panel = document.querySelector(
                            btn.getAttribute("data-bs-target"),
                        );
                        const panel_first_child =
                            panel && 0 < panel.childElementCount
                                ? panel.children[0]
                                : null;
                        if (panel && panel_first_child) {
                            panel_first_child.focus();
                        } else if (panel) {
                            panel.focus();
                        }
                    }
                }
            };
            changeTab();
            window.addEventListener("hashchange", () => changeTab(true));
        }

        let toasts = [...document.querySelectorAll(".toast")];
        if (0 < toasts.length) {
            exports.Toast = (await import("bootstrap/js/dist/toast")).default;
            // noinspection JSValidateTypes,JSUnusedAssignment
            toasts = toasts.map((el) => new exports.Toast(el));
        }

        let tooltips = [
            ...document.querySelectorAll(
                "[data-bs-toggle='tooltip'][data-bs-title]",
            ),
        ];
        if (0 < tooltips.length) {
            exports.Tooltip = (
                await import("bootstrap/js/dist/tooltip")
            ).default;
            // noinspection JSValidateTypes,JSUnusedAssignment
            tooltips = tooltips.map((el) => new exports.Tooltip(el));
        }

        //console.log("Bootstrap exports", exports);
        return exports;
    };

    static #setupAccordions(Collapse) {
        const accordions = [...document.querySelectorAll(".accordion")];
        accordions.forEach((accordion) => {
            const expandCollapseAllBtn = accordion.querySelector(
                ".accordion-btn-expand-collapse-all",
            );
            let expandCollapseAllBtnLabels;
            let changeExpandCollapseAllBtnLabel;
            let expandCollapseAllBtnClicked = false;
            let bsCollapseInstances;
            if (expandCollapseAllBtn) {
                expandCollapseAllBtnLabels = {
                    collapseAll: expandCollapseAllBtn.getAttribute(
                        "data-label-collapse-all",
                    ),
                    expandAll: expandCollapseAllBtn.getAttribute(
                        "data-label-expand-all",
                    ),
                };
                changeExpandCollapseAllBtnLabel = (showExpandAll) => {
                    expandCollapseAllBtn.setAttribute(
                        "aria-expanded",
                        showExpandAll ? "false" : "true",
                    );
                    expandCollapseAllBtn.textContent = showExpandAll
                        ? expandCollapseAllBtnLabels.expandAll
                        : expandCollapseAllBtnLabels.collapseAll;
                };
                bsCollapseInstances = new WeakMap();
                expandCollapseAllBtn.addEventListener("click", () => {
                    expandCollapseAllBtnClicked = true;
                    const btnExpanded =
                        "true" ===
                        expandCollapseAllBtn.getAttribute("aria-expanded");
                    changeExpandCollapseAllBtnLabel(btnExpanded);
                    collapsibles.forEach((collapsible) => {
                        const bsCollapse = bsCollapseInstances.get(collapsible);
                        if (!(bsCollapse instanceof Collapse)) {
                            return;
                        }

                        if (btnExpanded) {
                            bsCollapse.hide();
                        } else {
                            bsCollapse.show();
                        }
                    });
                    expandCollapseAllBtnClicked = false;
                });
            }

            const collapsibles = [
                ...accordion.querySelectorAll(".accordion-collapse"),
            ];
            collapsibles.forEach((collapsible) => {
                if (expandCollapseAllBtn) {
                    bsCollapseInstances.set(
                        collapsible,
                        new Collapse(collapsible, {
                            toggle: false,
                        }),
                    );
                }

                const item = collapsible.closest(".accordion-item");
                collapsible.addEventListener("show.bs.collapse", () => {
                    item.classList.add("active");

                    if (expandCollapseAllBtn && !expandCollapseAllBtnClicked) {
                        changeExpandCollapseAllBtnLabel(false);
                    }
                });
                collapsible.addEventListener("hide.bs.collapse", () =>
                    item.classList.remove("active"),
                );

                if (expandCollapseAllBtn) {
                    collapsible.addEventListener("hidden.bs.collapse", () => {
                        if (!expandCollapseAllBtnClicked) {
                            const allCollapsed = collapsibles.every(
                                (_collapsible) =>
                                    !_collapsible.classList.contains("show"),
                            );
                            if (allCollapsed) {
                                changeExpandCollapseAllBtnLabel(true);
                            }
                        }
                    });
                }
            });
        });
    }
}

export default Bootstrap;
